import { init, RematchDispatch, RematchRootState } from '@rematch/core';
import loadingPlugin, { ExtraModelsFromLoading } from '@rematch/loading';
import createPersistPlugin from '@rematch/persist';
import storage from 'redux-persist/lib/storage';
import { models, RootModel } from '../store';

const persistPlugin: any = createPersistPlugin({
	key: 'root',
	storage,
	version: 2,
	whitelist: [
		'auth',          // keep — login state must persist across sessions
		'usersGroups',   // keep — user/group membership is stable config data
		'vehicles',      // keep — vehicle registry (not live location data)
		'fleets',        // keep — fleet config is stable
		'usersGroupDetail',
		'filters',       // keep — user's date filter preferences
		// 'overview'    // REMOVED — live fleet metrics must always be fresh;
		                 // persisting causes stale vehicle status, yesterday's
		                 // health/usage/cost data to appear on next session open
		'appStore',      // keep — theme/language/dir settings
		'geofences',
		'help',
		'notifications',
		'roles',
		'reports'
	],
});

type FullModel = ExtraModelsFromLoading<RootModel>;

export const store = init<RootModel, FullModel>({
	models,
	plugins: [persistPlugin, loadingPlugin()],
});

export type Store = typeof store;
export type Dispatch = RematchDispatch<RootModel>;
export type RootState = RematchRootState<RootModel, FullModel>;